<template>
	<div class="form-group form-group--wide"
	     :class="containerClass"
	     v-show="!fieldProps.HIDDEN || fieldProps.HIDDEN == 'N'">
		<!--Google recaptcha-->
		<slot name="recaptcha"></slot>
		<!--./Google recaptcha-->
		<template v-if="!isRecaptcha">
			<slot></slot>
			<label class="control-label"
			       :class="(fieldValue || inputFocus) ? 'form-field__label_active' : ''"
			       v-if="withLabel"
			       :tabindex="tabindex"
			       :for="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			       :title="fieldProps.TITLE ? fieldProps.TITLE : ''"
			       @keyup.enter="$emit('change-value')"
			       @click="labelSwitch">
				<span v-html="fieldProps.TITLE"></span>
				<span class="form-field__starrequired"
				      v-if="fieldProps.REQUIRED == 'Y'">*</span>
			</label>
			<i class="bar" v-if="isTextInput"></i>
			<label v-show="isError && canShowErrors" class="help-label" v-html="isError"></label>
		</template>
		<slot name="captcha-img"></slot>
	</div>
</template>
<script>
export default {
	name: "FormFieldWrap",
	props: {
		fieldProps: {
			type: [Object, Array],
			default: function () {
				return {}
			}
		},
		isError: {
			type: [String, Boolean],
			default: ''
		},
		isSwitch: {
			type: Boolean,
			default: false
		},
		inputFocus: {
			type: Boolean,
			default: false
		},
		fieldValue: {
			type: [String, Number, Boolean],
			default: ''
		},
		isRecaptcha: {
			type: Boolean,
			default: false
		},
		withLabel: {
			type: Boolean,
			default: true
		},
		tabindex: {
			type: Number,
			default: -1
		},
		/**
		 * Если true, то показывать ошибки только после потери фокуса,
		 * Иначе всегда
		 */
		showErrorsOnBlur: {
			type: Boolean,
			default: true,
		}
	},
	computed: {
		containerClass() {
			let result = [];

			if (this.fieldProps.ROW_CLASS) {
				result.push(this.fieldProps.ROW_CLASS);
			}

			if (this.fieldProps.TYPE) {
				result.push('form-field_' + this.fieldProps.TYPE);
			}

			if (this.fieldProps.CLASS) {
				result.push('form-field_' + this.fieldProps.CLASS);
			} else {
				result.push('form-field_' + this.fieldProps.CODE);
			}

			if (this.isSwitch) {
				result.push('switch');
			}

			if (this.isError && !this.inputFocus) {
				result.push('form-field_error');
			}

			if (this.fieldValue) {
				result.push('form-field_filled');

				if (this.fieldProps.TYPE == 'checkbox') {
					result.push('form-field_checked');
				}
			}

			return result.join(' ');
		},
		isTextInput() {
			return ['text', 'email', 'phone'].includes(this.fieldProps.TYPE);
		},
		/** Показывать ошибки только если после потери фокуса */
		canShowErrors() {
			return this.showErrorsOnBlur ? !this.inputFocus : true;
		}
	},
	methods: {
		labelSwitch() {
			let id = this.fieldProps.ID ? this.fieldProps.ID : this.fieldProps.CODE;

			this.$emit('labelSwitch', true);
			let input = document.getElementById(id);

			input.focus();
		},
	}
}
</script>
<style scoped>
.help-label,
.form__delete {
	display: block;
}
</style>